import * as React from 'react';

export class HistoryTimeLine extends React.Component {
    public render() {
        return ( 
        <div className="historyTimeLine">
            {this.props.children}
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/History/CollisionTimeLine/HistoryTimeLine.tsx